import React from "react";
import { Fade } from "@mui/material";

const TransitionWrapper = ({ children }) => {
  return (
    <Fade in timeout={300}>
      <div>{children}</div>
    </Fade>
  );
};

export default TransitionWrapper;